module.exports = __webpack_public_path__ + "assets/1@2x.3c99f42d.png";